import React from 'react'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { BaseCard, CardField } from 'components'

export const CardCaso = (props) => {
  moment.locale('pt-br', localization)
  const { caso, handleClick } = props

  return (
    caso ? (
      <BaseCard
        avatar="CASO"
        title="Caso"
        onClick={() => handleClick(caso.id)}
        onNovaAba={() => handleClick(caso.id, true)}
      >
        <CardField label="Identificador" value={caso.identificador} />
        <CardField label="Setor responsável" value={caso.setRes?.nome} />
        <CardField label="Data do registro" value={moment(caso.created_at).format('LLLL')} />
        <CardField
          label="Descrição"
          value={
            caso.descricao && caso.descricao.length > 100
              ? `${caso.descricao.slice(0, 100)}...`
              : caso.descricao || 'sem descrição'
          }
        />
      </BaseCard>
    ) : null
  )
}
